const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const WonkyButton = require("./WonkyButton");
const TimerWrapper = require("./TimerWrapper");
const MessageModal = require("./MessageModal");
const AssetsUtil = require("../util/AssetsUtil");
const CopyTable = require("../util/CopyTable");

const styles = require("./styles/UserRateLimitModal.css");

module.exports = createReactClass({
	displayName: "UserRateLimitModal",

	propTypes: {
		// Assumed not to change after mount
		initialSeconds: PT.number.isRequired,
	},

	onRefresh: function() {
		window.location.reload();
	},

	renderButton: function(left) {
		if (left > 0) {
			return (
				<div className={styles.buttons}>
					<WonkyButton
						buttonType="refresh"
						buttonText={String(left)}
						overrideButtonTextWidth="refresh"
						isDisabled={true}
					/>
				</div>
			);
		} else {
			return (
				<div className={styles.buttons}>
					<WonkyButton buttonType="refresh" handleClick={this.onRefresh} />
				</div>
			);
		}
	},

	renderModal: function(initialSeconds, left) {
		return (
			<MessageModal
				styleType="generic"
				size="text-generic"
				onClose={this.onClose}
				levelType="aboveAll"
				backdropClass={styles.darkerBackdrop}
				cannotClose={true}
				portalContainer={null}
			>
				<div className={styles.wrapper}>
					<img
						className={styles.errorImage}
						src={AssetsUtil.getGotProblems()}
					/>
					<div className={styles.errorMessage}>
						{CopyTable.forUserRateLimitModal(initialSeconds)}
					</div>
					{this.renderButton(left)}
				</div>
			</MessageModal>
		);
	},

	render: function() {
		return (
			<TimerWrapper
				initialSeconds={this.props.initialSeconds}
				render={this.renderModal}
			/>
		);
	},
});
